module.exports = __webpack_public_path__ + "img/pic3.70939bd5.jpg";